export default __webpack_public_path__ + "static/media/header-sticky-d.f7af2905.png";